import { shallowRef } from 'vue'

// AY swaps `push` on both queues once it loads, so a push after load still runs.

// Only ever set in the browser, so a server render always sees false.
const managerFailed = shallowRef(false)

export function ensureAyManagerEnv(): void {
  if (!window.ayManagerEnv) {
    Reflect.set(window, 'ayManagerEnv', { cmd: [] })
  }
}

/** Run once the AY analytics SDK is up. */
export function whenAyReady(fn: () => void): void {
  window.assertiveQueue = window.assertiveQueue || []
  window.assertiveQueue.push(fn)
}

/** Run inside the AY yield manager's command queue. */
export function withAyManager(fn: () => void): void {
  if (managerFailed.value) return
  ensureAyManagerEnv()
  window.ayManagerEnv?.cmd.push(fn)
}

/** Nothing will drain the queue after a failed load, so its work is dropped. */
export function markAyManagerFailed(): void {
  managerFailed.value = true
  window.ayManagerEnv?.cmd.splice(0)
}

export function ayManagerFailed(): boolean {
  return managerFailed.value
}

export function resetAyManagerFailedForTests(): void {
  managerFailed.value = false
}
